import { object, string } from "yup";

export const validationSchema = object({
  locationInTerminal: string().required("This field is required"),
  vehicleStatusId: string().required("This field is required"),
  dateTime: string().required("This field is required"),
  driverName: string()
    .required("This field is required")
    .max(50, "Maximum 50 characters allowed")
    .matches(/^[a-zA-Z ]*$/, "Only alphabets are allowed for this field "),
  driverFatherName: string()
    .max(50, "Maximum 50 characters allowed")
    .matches(/^[a-zA-Z ]*$/, "Only alphabets are allowed for this field "),

  exporterName: string().max(50, "Maximum 50 characters allowed"),
  // .matches(/^[a-zA-Z ]*$/, "Only alphabets are allowed for this field "),

  importerName: string().max(50, "Maximum 50 characters allowed"),
  // .matches(/^[a-zA-Z ]*$/, "Only alphabets are allowed for this field "),
  supplierName: string()
    .max(50, "Maximum 50 characters allowed")
    .matches(/^[a-zA-Z ]*$/, "Only alphabets are allowed for this field "),
  agentName: string()
    .max(50, "Maximum 50 characters allowed")
    .matches(/^[a-zA-Z ]*$/, "Only alphabets are allowed for this field "),
  vehicleRegNumber: string()
    .required("This field is required")
    .max(15, "Maximum 15 characters allowed")
    .matches(/^[a-zA-Z0-9 ]*$/, "Only alphabets are allowed for this field "),
  vehicleTypeId: string().required("This field is required"),
  travellingDocNumber: string()
    .required("This field is required")
    .min(1, "Minimum 1 characters are required")
    .max(50, "Maximum 50 characters are allowed"),
  containerNumber: string()
    .required("This field is required")
    .max(50, "Maximum 50 characters allowed"),
  sealNo: string().max(50, "Maximum 50 characters allowed"),
  webBocId: string().max(50, "Maximum 50 characters allowed"),
  consignmentTypeId: string().required("This field is required"),
  commercial: string().required("This field is required"),
  gdNo: string().when("consignmentTypeName", {
    is: (value: any) => {
      if (value == "Export" || value == "export") {
        return true;
      }
      // return !value;
    },
    then: string().required("This field is required."),
    otherwise: string(),
  }),
  webocVehicleNumber: string().when("consignmentTypeName", {
    is: (value: any) => {
      if (value == "Export" || value == "export") {
        return true;
      }
      // return !value;
    },
    then: string().required("This field is required."),
    otherwise: string(),
  }),
  containerList: string().when("consignmentTypeName", {
    is: (value: any) => (value || "").toLowerCase() === "fcl-export",
    then: string().required("This field is required."),
    otherwise: string(),
  }),
  cargoTypeIds: string().required("This field is required"),
  vehicleColor: string().max(50, "Maximum 50 characters are allowed"),
  driverMobileNumber: string()
    .max(20, "Maximum 12 characters allowed")
    .min(1, "min 1 characters allowed")
    .test("len", "Invalid Phone Number No.", (val = "") => {
      const val_length_without_dashes = val.replace(/-|_/g, "").length;
      return val_length_without_dashes === 13 || val_length_without_dashes === 0;
    }),
  agentMobileNumber: string()
    .max(20, "Maximum 12 characters allowed")
    .min(1, "min 1 characters allowed")
    .test("len", "Invalid Phone Number No.", (val = "") => {
      const val_length_without_dashes = val.replace(/-|_/g, "").length;
      return val_length_without_dashes === 13 || val_length_without_dashes === 0;
    }),
  importerPhoneNumber: string()
    .max(20, "Maximum 12 characters allowed")
    .min(1, "min 1 characters allowed")
    .test("len", "Invalid Phone Number No.", (val = "") => {
      const val_length_without_dashes = val.replace(/-|_/g, "").length;
      return val_length_without_dashes === 13 || val_length_without_dashes === 0;
    }),
  exporterPhoneNumber: string()
    .max(20, "Maximum 12 characters allowed")
    .min(1, "min 1 characters allowed")
    .test("len", "Invalid Phone Number No.", (val = "") => {
      const val_length_without_dashes = val.replace(/-|_/g, "").length;
      return val_length_without_dashes === 13 || val_length_without_dashes === 0;
    }),
  vehicleMake: string()
    .max(4, "Maximum 4 characters allowed")
    .min(1, "min 1 characters allowed")
    .test("len", "Invalid Year", (val = "") => {
      const val_length_without_dashes = val.replace(/-|_/g, "").length;
      return val_length_without_dashes === 4 || val_length_without_dashes === 0;
    }),
  slipNumber: string()
    .required("This field is required")
    .min(1, "Minimum 1 characters are required")
    .max(50, "Maximum 50 characters are allowed"),
  travellingDocType: string().required("This field is required"),
  crmNumber: string().max(50, "Maximum 50 characters are allowed"),
  eFormNumber: string().max(50, "Maximum 50 characters are allowed"),
  passNumber: string().max(50, "Maximum 50 characters are allowed"),
  vehicleChassisNumber: string().max(50, "Maximum 50 characters are allowed"),
  vehicleBrand: string()
    .max(50, "Maximum 50 characters are allowed")
    .matches(/^[a-zA-Z0-9- ]*$/, "Only alphabets are allowed for this field "),
  vehicleModel: string().max(50, "Maximum 50 characters are allowed"),
  driverNTN: string()
    .max(50, "Maximum 50 characters are allowed")
    .matches(/^[a-zA-Z0-9- ]*$/, "Only alphanumeric are allowed for this field "),
  driverCNIC: string()
    .max(25, "Maximum 25 characters are allowed")
    .matches(/^[A-Za-z0-9-,_ ]*$/, "Only alphanumeric are allowed for this field "),
  driverResident: string().max(50, "Maximum 50 characters are allowed"),
  remarks: string().max(3000, "Maximum 3000 characters are allowed"),
  notes: string().max(3000, "Maximum 3000 characters are allowed"),
});
